import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

interface MuiListItem {
    id: string;
    icon?: JSX.Element;
    text?: string | JSX.Element | JSX.Element[];
    secondaryAction?: string | JSX.Element | JSX.Element[];
    primaryText?: string;
    secondaryText?: string;
}

interface MuiSelectableListProps {
    items: MuiListItem[];
}

export const MuiList = ({ items }: MuiSelectableListProps) => {
    return (
        <List dense disablePadding>
            {items?.map(
                ({
                    id,
                    icon,
                    primaryText,
                    secondaryText,
                    text,
                    secondaryAction,
                }) => (
                    <ListItem key={id} secondaryAction={secondaryAction}>
                        {!!icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
                        <ListItemText
                            primary={primaryText}
                            secondary={secondaryText}
                            sx={!!secondaryAction ? { mr: 2 } : undefined}
                        >
                            {text}
                        </ListItemText>
                    </ListItem>
                )
            )}
        </List>
    );
};
